import { localStorageWrapper } from "@/utils/storage";
import { useEffect, useRef } from "react";

export default function OnlineHawzahChatWidget() {
    const isInitializedRef = useRef(false);

    useEffect(() => {
        const initWidget = async () => {
            if (
                typeof window !== "undefined" &&
                !isInitializedRef.current &&
                !localStorageWrapper.isImpersonated()
            ) {
                try {
                    // Load script if not already loaded
                    if (!document.getElementById("chatwidgetscript")) {
                        const script = document.createElement("script");
                        script.id = "chatwidgetscript";
                        script.src = process.env.NEXT_PUBLIC_CHAT_WIDGET_URL;
                        script.defer = true;
                        document.body.appendChild(script);

                        // Wait for ChatWidget to be available
                        await new Promise((resolve) => {
                            const checkWidget = () => {
                                if (window.ChatWidget) {
                                    resolve();
                                } else {
                                    setTimeout(checkWidget, 100);
                                }
                            };
                            checkWidget();
                        });
                    }

                    // Initialize the widget
                    if (window.ChatWidget && window.ChatWidget.init) {
                        await window.ChatWidget.init();
                        window.ChatWidget.isGoftinoReady().then(() => {
                            window.ChatWidget.setAuthToken(
                                localStorageWrapper.getToken()
                            );
                        });
                        isInitializedRef.current = true;
                    }
                } catch (error) {
                    console.error("Failed to initialize widget:", error);
                }
            }
        };

        initWidget();

        return () => {
            // Only dispose on component unmount
            if (
                window.ChatWidget &&
                window.ChatWidget.dispose &&
                isInitializedRef.current
            ) {
                window.ChatWidget.dispose();
                isInitializedRef.current = false;
            }
        };
    }, []);

    return <></>;
}
